export function buildUniqueValuesSql(
    localized: string,
    attrValue: string,
    from: string,
    where: string
) {
    return `
    SELECT attrs.value as value, attrs.key as key, ${localized} as label, count(*) as count
    FROM ${from} as product CROSS JOIN json_each(${attrValue}) as attrs
    ${where.length > 0 ? `WHERE  ${where}` : ''}
    GROUP BY attrs.value
    ORDER BY attrs.value ASC;
`
}
